import authActions from "./actions";
import storeActions from "redux/storeID/actions";
import { clearAuthStorage } from "util/session";

/**
 * Full session teardown: clear tokens + theme keys, wipe auth, reset store context.
 * Works as a thunk (redux-thunk is enabled).
 */
export const logoutAndClearSession = () => dispatch => {
  clearAuthStorage();
  dispatch(authActions.logout());
  dispatch(storeActions.resetStoreId());
};

export default logoutAndClearSession;
